/**
 * Hong Kong Banks for bank selection when bankCountry = Hong Kong
 * Source: Hong Kong Clearing House
 */

export interface HongKongBank {
  bankCode: string;
  bankName: string;
}

export const HONG_KONG_BANKS: HongKongBank[] = [
  { bankCode: "003", bankName: "STANDARD CHARTERED BANK (HONG KONG) LIMITED" },
  { bankCode: "004", bankName: "THE HONGKONG AND SHANGHAI BANKING CORPORATION LIMITED" },
  { bankCode: "005", bankName: "CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK" },
  { bankCode: "006", bankName: "CITIBANK, N.A." },
  { bankCode: "007", bankName: "JPMORGAN CHASE BANK, N.A." },
  { bankCode: "008", bankName: "NATWEST MARKETS PLC" },
  { bankCode: "009", bankName: "CHINA CONSTRUCTION BANK (ASIA) CORPORATION LIMITED" },
  { bankCode: "012", bankName: "BANK OF CHINA (HONG KONG) LIMITED" },
  { bankCode: "015", bankName: "THE BANK OF EAST ASIA, LIMITED" },
  { bankCode: "016", bankName: "DBS BANK (HONG KONG) LIMITED" },
  { bankCode: "018", bankName: "CHINA CITIC BANK INTERNATIONAL LIMITED" },
  { bankCode: "020", bankName: "CMB WING LUNG BANK LIMITED." },
  { bankCode: "022", bankName: "OVERSEA-CHINESE BANKING CORPORATION LTD." },
  { bankCode: "024", bankName: "HANG SENG BANK LTD." },
  { bankCode: "025", bankName: "SHANGHAI COMMERCIAL BANK LTD." },
  { bankCode: "027", bankName: "BANK OF COMMUNICATIONS CO., LTD" },
  { bankCode: "028", bankName: "PUBLIC BANK (HONG KONG) LIMITED" },
  { bankCode: "035", bankName: "OCBC WING HANG BANK LIMITED" },
  { bankCode: "038", bankName: "TAI YAU BANK LTD." },
  { bankCode: "039", bankName: "CHIYU BANKING CORPORATION LTD." },
  { bankCode: "040", bankName: "DAH SING BANK, LTD." },
  { bankCode: "041", bankName: "CHONG HING BANK LIMITED" },
  { bankCode: "043", bankName: "NANYANG COMMERCIAL BANK, LTD." },
  { bankCode: "045", bankName: "UCO BANK" },
  { bankCode: "046", bankName: "KEB HANA BANK" },
  { bankCode: "047", bankName: "MUFG BANK, LTD." },
  { bankCode: "049", bankName: "BANGKOK BANK PUBLIC COMPANY LIMITED" },
  { bankCode: "050", bankName: "INDIAN OVERSEAS BANK" },
  { bankCode: "054", bankName: "DEUTSCHE BANK AG" },
  { bankCode: "055", bankName: "BANK OF AMERICA, N.A." },
  { bankCode: "056", bankName: "BNP PARIBAS" },
  { bankCode: "058", bankName: "BANK OF INDIA" },
  { bankCode: "060", bankName: "NATIONAL BANK OF PAKISTAN" },
  { bankCode: "061", bankName: "TAI SANG BANK LIMITED" },
  { bankCode: "063", bankName: "MALAYAN BANKING BERHAD (MAYBANK)" },
  { bankCode: "065", bankName: "SUMITOMO MITSUI BANKING CORPORATION" },
  { bankCode: "066", bankName: "PT. BANK NEGARA INDONESIA (PERSERO) TBK." },
  { bankCode: "067", bankName: "BDO UNIBANK, INC." },
  { bankCode: "071", bankName: "UNITED OVERSEAS BANK LTD." },
  { bankCode: "072", bankName: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA (ASIA) LIMITED" },
  { bankCode: "074", bankName: "BARCLAYS BANK PLC." },
  { bankCode: "076", bankName: "THE BANK OF NOVA SCOTIA" },
  { bankCode: "080", bankName: "ROYAL BANK OF CANADA" },
  { bankCode: "081", bankName: "SOCIETE GENERALE" },
  { bankCode: "082", bankName: "STATE BANK OF INDIA" },
  { bankCode: "085", bankName: "THE TORONTO-DOMINION BANK" },
  { bankCode: "086", bankName: "BANK OF MONTREAL" },
  { bankCode: "092", bankName: "CANADIAN IMPERIAL BANK OF COMMERCE" },
  { bankCode: "097", bankName: "COMMERZBANK AG" },
  { bankCode: "103", bankName: "UBS AG, HONG KONG" },
  { bankCode: "106", bankName: "HSBC BANK USA, N.A." },
  { bankCode: "109", bankName: "MIZUHO BANK, LTD., HONG KONG BRANCH" },
  { bankCode: "113", bankName: "DZ BANK AG DEUTSCHE ZENTRAL-GENOSSENSCHAFTSBANK" },
  { bankCode: "118", bankName: "WOORI BANK" },
  { bankCode: "119", bankName: "PHILIPPINE NATIONAL BANK" },
  { bankCode: "128", bankName: "FUBON BANK (HONG KONG) LIMITED" },
  { bankCode: "138", bankName: "MITSUBISHI UFJ TRUST AND BANKING CORPORATION" },
  { bankCode: "139", bankName: "THE BANK OF NEW YORK MELLON" },
  { bankCode: "145", bankName: "ING BANK N.V." },
  { bankCode: "147", bankName: "BANCO BILBAO VIZCAYA ARGENTARIA, S.A." },
  { bankCode: "150", bankName: "NATIONAL AUSTRALIA BANK LIMITED" },
  { bankCode: "151", bankName: "WESTPAC BANKING CORPORATION" },
  { bankCode: "152", bankName: "AUSTRALIA AND NEW ZEALAND BANKING GROUP LTD." },
  { bankCode: "153", bankName: "COMMONWEALTH BANK OF AUSTRALIA" },
  { bankCode: "161", bankName: "INTESA SANPAOLO S.P.A." },
  { bankCode: "164", bankName: "UNICREDIT BANK AG" },
  { bankCode: "165", bankName: "SVENSKA HANDELSBANKEN AB (PUBL)" },
  { bankCode: "170", bankName: "THE CHIBA BANK LTD." },
  { bankCode: "178", bankName: "KBC BANK N.V., HONG KONG BRANCH" },
  { bankCode: "180", bankName: "WELLS FARGO BANK, N.A., HONG KONG BRANCH" },
  { bankCode: "183", bankName: "COÖPERATIEVE RABOBANK U.A." },
  { bankCode: "185", bankName: "DBS BANK LTD., HONG KONG BRANCH" },
  { bankCode: "186", bankName: "THE SHIZUOKA BANK LTD." },
  { bankCode: "188", bankName: "THE HACHIJUNI BANK, LTD." },
  { bankCode: "198", bankName: "HUA NAN COMMERCIAL BANK, LTD." },
  { bankCode: "199", bankName: "THE SHIGA BANK, LTD." },
  { bankCode: "201", bankName: "BANK OF TAIWAN" },
  { bankCode: "202", bankName: "THE CHUGOKU BANK LIMITED" },
  { bankCode: "203", bankName: "FIRST COMMERCIAL BANK" },
  { bankCode: "206", bankName: "CHANG HWA COMMERCIAL BANK, LTD." },
  { bankCode: "210", bankName: "NATIXIS" },
  { bankCode: "214", bankName: "INDUSTRIAL AND COMMERCIAL BANK OF CHINA LIMITED" },
  { bankCode: "220", bankName: "STATE STREET BANK AND TRUST COMPANY" },
  { bankCode: "221", bankName: "CHINA CONSTRUCTION BANK CORPORATION" },
  { bankCode: "222", bankName: "AGRICULTURAL BANK OF CHINA LIMITED" },
  { bankCode: "227", bankName: "ERSTE GROUP BANK AG" },
  { bankCode: "229", bankName: "CTBC BANK CO., LTD." },
  { bankCode: "230", bankName: "TAIWAN BUSINESS BANK, LTD." },
  { bankCode: "233", bankName: "CREDIT SUISSE AG" },
  { bankCode: "236", bankName: "CATHAY UNITED BANK COMPANY, LIMITED" },
  { bankCode: "237", bankName: "EFG BANK AG" },
  { bankCode: "238", bankName: "CHINA MERCHANTS BANK CO., LTD." },
  { bankCode: "239", bankName: "TAIPEI FUBON COMMERCIAL BANK CO., LTD." },
  { bankCode: "241", bankName: "BANK SINOPAC" },
  { bankCode: "242", bankName: "MEGA INTERNATIONAL COMMERCIAL BANK CO., LTD." },
  { bankCode: "243", bankName: "E.SUN COMMERCIAL BANK, LTD." },
  { bankCode: "245", bankName: "TAISHIN INTERNATIONAL BANK CO., LTD." },
  { bankCode: "248", bankName: "HONG LEONG BANK BERHAD" },
  { bankCode: "249", bankName: "STANDARD CHARTERED BANK HONG KONG BRANCH" },
  { bankCode: "250", bankName: "CITIBANK (HONG KONG) LIMITED" },
  { bankCode: "251", bankName: "ICICI BANK LIMITED" },
  { bankCode: "254", bankName: "MELLI BANK PLC" },
  { bankCode: "258", bankName: "EAST WEST BANK" },
  { bankCode: "259", bankName: "BANK OF BARODA" },
  { bankCode: "260", bankName: "FAR EASTERN INTERNATIONAL BANK" },
  { bankCode: "262", bankName: "CANARA BANK" },
  { bankCode: "263", bankName: "CATHAY BANK" },
  { bankCode: "264", bankName: "LAND BANK OF TAIWAN CO., LTD." },
  { bankCode: "265", bankName: "TAIWAN COOPERATIVE BANK, LTD." },
  { bankCode: "266", bankName: "PUNJAB NATIONAL BANK" },
  { bankCode: "267", bankName: "BANCO SANTANDER S.A." },
  { bankCode: "268", bankName: "UNION BANK OF INDIA" },
  { bankCode: "269", bankName: "THE SHANGHAI COMMERCIAL & SAVINGS BANK, LTD." },
  { bankCode: "271", bankName: "INDUSTRIAL BANK OF KOREA" },
  { bankCode: "272", bankName: "BANK OF SINGAPORE LIMITED" },
  { bankCode: "273", bankName: "SHINHAN BANK" },
  { bankCode: "274", bankName: "O-BANK CO., LTD" },
  { bankCode: "275", bankName: "BNP PARIBAS SECURITIES SERVICES" },
  { bankCode: "276", bankName: "CHINA DEVELOPMENT BANK" },
  { bankCode: "277", bankName: "FIRST ABU DHABI BANK PJSC" },
  { bankCode: "278", bankName: "BANK J. SAFRA SARASIN LTD." },
  { bankCode: "307", bankName: "ABN AMRO BANK N.V." },
  { bankCode: "308", bankName: "HDFC BANK LIMITED" },
  { bankCode: "309", bankName: "UNION BANCAIRE PRIVEE, UBP SA" },
  { bankCode: "316", bankName: "SKANDINAVISKA ENSKILDA BANKEN AB" },
  { bankCode: "320", bankName: "BANK JULIUS BAER & CO. LTD." },
  { bankCode: "324", bankName: "CREDIT INDUSTRIEL ET COMMERCIAL" },
  { bankCode: "337", bankName: "TAIWAN SHIN KONG COMMERCIAL BANK CO., LTD." },
  { bankCode: "338", bankName: "BANK OF CHINA LIMITED, HONG KONG BRANCH" },
  { bankCode: "339", bankName: "CA INDOSUEZ (SWITZERLAND) SA" },
  { bankCode: "341", bankName: "ICBC STANDARD BANK PLC" },
  { bankCode: "342", bankName: "LGT BANK AG" },
  { bankCode: "344", bankName: "MACQUARIE BANK LIMITED" },
  { bankCode: "345", bankName: "SHANGHAI PUDONG DEVELOPMENT BANK CO., LTD." },
  { bankCode: "353", bankName: "CHINA MINSHENG BANKING CORP., LTD." },
  { bankCode: "357", bankName: "PICTET & CIE (EUROPE) S.A." },
  { bankCode: "359", bankName: "CHINA GUANGFA BANK CO., LTD." },
  { bankCode: "361", bankName: "CHINA BOHAI BANK CO., LTD." },
  { bankCode: "368", bankName: "CHINA EVERBRIGHT BANK CO., LTD." },
  { bankCode: "371", bankName: "SUMITOMO MITSUI TRUST BANK, LIMITED" },
  { bankCode: "372", bankName: "BANK OF SHANGHAI (HONG KONG) LIMITED" },
  { bankCode: "374", bankName: "CIMB BANK BERHAD" },
  { bankCode: "377", bankName: "INDUSTRIAL BANK CO., LTD" },
  { bankCode: "378", bankName: "YUANTA COMMERCIAL BANK CO., LTD." },
  { bankCode: "379", bankName: "MASHREQ BANK - PUBLIC SHAREHOLDING COMPANY" },
  { bankCode: "381", bankName: "KOOKMIN BANK" },
  { bankCode: "382", bankName: "BANK OF COMMUNICATIONS (HONG KONG) LIMITED" },
  { bankCode: "383", bankName: "CHINA ZHESHANG BANK CO., LTD." },
  { bankCode: "384", bankName: "MORGAN STANLEY BANK ASIA LIMITED" },
  { bankCode: "385", bankName: "PING AN BANK CO., LTD." },
  { bankCode: "386", bankName: "HUA XIA BANK CO., LIMITED" },
  { bankCode: "387", bankName: "ZA BANK LIMITED" },
  { bankCode: "388", bankName: "LIVI VB LIMITED" },
  { bankCode: "389", bankName: "MOX BANK LIMITED" },
  { bankCode: "390", bankName: "WELAB BANK LIMITED" },
  { bankCode: "391", bankName: "FUSION BANK LIMITED" },
  { bankCode: "392", bankName: "PING AN ONECONNECT BANK (HONG KONG) LIMITED" },
  { bankCode: "393", bankName: "ANT BANK (HONG KONG) LIMITED" },
  { bankCode: "394", bankName: "QATAR NATIONAL BANK (Q.P.S.C.)" },
  { bankCode: "395", bankName: "AIRSTAR BANK LIMITED" },
  { bankCode: "802", bankName: "HONG KONG SECURITIES CLEARING COMPANY LIMITED" },
  { bankCode: "868", bankName: "CLS BANK INTERNATIONAL" },
];

/**
 * Get bank names as dropdown options (sorted alphabetically)
 */
export const getHongKongBankOptions = (): string[] => {
  return HONG_KONG_BANKS.map((bank) => bank.bankName).sort((a, b) =>
    a.localeCompare(b)
  );
};

/**
 * Get bank code by bank name
 */
export const getBankCodeByName = (bankName: string): string | undefined => {
  const bank = HONG_KONG_BANKS.find((b) => b.bankName === bankName);
  return bank?.bankCode;
};

/**
 * Get bank name by bank code
 */
export const getBankNameByCode = (bankCode: string): string | undefined => {
  const bank = HONG_KONG_BANKS.find((b) => b.bankCode === bankCode);
  return bank?.bankName;
};

/**
 * Check if a country is Hong Kong
 */
export const isHongKong = (country: string | null | undefined): boolean => {
  if (!country) return false;
  const normalizedCountry = country.toLowerCase().trim();
  return (
    normalizedCountry === "hong kong" ||
    normalizedCountry === "hk" ||
    normalizedCountry === "hong kong sar" ||
    normalizedCountry === "hong kong, china"
  );
};
